import { makeAutoObservable, runInAction } from "mobx";

class LimitAlertStore {
  data = {
    show: false,
    type: "",
  }
  constructor() {
    makeAutoObservable(this);
  }

  setData(n) {
    if(!n) return
    runInAction(() => {
      this.data = {
        ...this.data,
        ...n
      }
    })
  }
}

const limitAlertStore = new LimitAlertStore();
export default limitAlertStore;